<template>
  <div id="datasetPicker">
    <h2>Choose Dataset(s)</h2>
    <div class="card p-2 mb-5">
      <div
        class="mb-2"
      >
        <span
          v-for="(crumb, i) in breadcrumbs"
          v-bind:key="i"
        >
          <b-badge
            pill
            variant="primary"
            @click="launchFolder(crumb, true)"
            class="clickable"
          >{{ crumb.name }}</b-badge><span v-if="(i + 1) !== breadcrumbs.length"> / </span>
        </span>
      </div>
      <div class="scroll">
        <!-- FOLDERS -->
        <div class="list-group mb-2 folders">
          <div
            v-for="(folder, i) in $store.state.multivariate.folders"
            v-bind:key="i"
            class="list-container"
          >
            <a
              @click="launchFolder(folder)"
              class="list-group-item list-group-item-action clickable mb-2 folder"
            >
              <p class="lead mb-1"><i class="fas fa-folder"></i> {{ folder.name }}</p>
              <p class="mb-1">{{ folder.description }}</p>
            </a>
          </div>
        </div><!-- /.list-group -->
        <!-- DATASETS -->
        <div class="list-group sets">
          <div
          v-for="(dataset, i) in $store.state.multivariate.datasets"
          v-bind:key="i"
          class="list-container"
          >
            <a
              @click="launchDataset(dataset)"
              class="list-group-item list-group-item-action clickable handle mb-2"
            >
              <p class="lead mb-1"><i v-if="dataset.dynamic" class="fas fa-satellite-dish" v-b-tooltip.hover.top="'Dynamic Dataset'"></i> {{ dataset.name }}</p>
              <p class="mb-1">{{ dataset.description }}</p>
            </a>
          </div>
        </div><!-- /.list-group -->
      </div><!-- /.scroll -->
    </div><!-- /.card -->
  </div><!-- /#dataset-picker -->
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
  computed: {
    breadcrumbs: {
      get () {
        return this.$store.state.multivariate.breadcrumbs
      },
      set (value) {
        this.$store.commit('multivariate/setStateProperty', { property: 'breadcrumbs', value: value })
      }
    },
    chosenDatasets: {
      get () {
        return this.$store.state.multivariate.chosenDatasets
      },
      set (value) {
        this.$store.commit('multivariate/setStateProperty', { property: 'chosenDatasets', value: value })
      }
    }
  },
  created () {
    this.fetchDatasets()
    this.fetchFolders()
  },
  methods: {
    fetchDatasets () {
      const farmId = this.$store.state.farm && this.$store.state.farm.id
      const folderId = this.$store.state.multivariate.folder.id
      // Keep state.farmId in sync so `post` has it after the user
      // navigates through folders (the legacy plugin pulled it from
      // the route — we now pull it from the loaded farm).
      this.$store.commit('multivariate/setStateProperty', { property: 'farmId', value: farmId })
      fb.datasetsCollection
        .where('farmId', '==', farmId)
        .where('folderId', '==', folderId)
        .orderBy('updatedOn', 'desc')
        .get()
        .then(snap => {
          const datasets = snap.docs.map(d => ({ id: d.id, ...d.data() }))
          this.$store.commit('multivariate/setStateProperty', { property: 'datasets', value: datasets })
        }).catch(err => {
          console.log(err.message)
        })
    },
    fetchFolders () {
      const farmId = this.$store.state.farm && this.$store.state.farm.id
      const folderId = this.$store.state.multivariate.folder.id
      fb.foldersCollection
        .where('farmId', '==', farmId)
        .where('folderId', '==', folderId)
        .orderBy('name', 'asc')
        .get()
        .then(snap => {
          const folders = snap.docs.map(d => ({ id: d.id, ...d.data() }))
          this.$store.commit('multivariate/setStateProperty', { property: 'folders', value: folders })
        }).catch(err => {
          console.log(err.message)
        })
    },
    launchFolder (folder, fromCrumb) {
      if (this.breadcrumbs.length < 1) {
        this.breadcrumbs = [{ name: 'Root', id: 'root' }]
      }
      if (fromCrumb) {
        const newBreadcrumbs = []
        this.breadcrumbs.some(crumb => {
          if (crumb.id !== folder.id) {
            newBreadcrumbs.push(crumb)
          } else {
            newBreadcrumbs.push(crumb)
            return true
          }
        })
        this.breadcrumbs = newBreadcrumbs
      } else {
        this.breadcrumbs.push(folder)
      }
      this.$store.commit('multivariate/setStateProperty', { property: 'folder', value: folder })
      this.fetchDatasets()
      this.fetchFolders()
    },
    launchDataset (dataset) {
      this.chosenDatasets.push(dataset)
    }
  }
}
</script>

<style scoped>
.scroll {
  max-height: calc(100vh - 130px);
  overflow: scroll;
}
.card > .list-group {
  border-top: none;
  border-bottom: none;
}
.folder {
  background-color: #eee;
}

.badge.clickable:hover {
  box-shadow: 1px 2px 4px rgba(0,0,0,0.5);
}
</style>
